import dayjs from 'dayjs';
import { addHistory, ApiService } from './api';
import { HistoryStore } from '@/utils/store/store';
import { handleError } from '@/utils/helpers';
import { handleWarnWithErr } from '@/utils/ui-helpers';
import { ERROR_MESSAGES } from '@/constants/messages';

export interface SaveHistoryParams {
  userId: string;
  email?: string;
  result: string;
  input: {
    Content?: string;
    Industry?: string;
    Output_type?: string;
    [key: string]: unknown;
  };
}

/**
 * 保存历史记录并提交评测
 * 统一处理历史记录保存和 evaluation 提交逻辑
 */
export async function saveHistoryAndEvaluation(params: SaveHistoryParams): Promise<{
  success: boolean;
  historyId?: string;
  error?: Error;
}> {
  const { userId, email, result, input } = params;

  try {
    const response = await addHistory({
      userId,
      email,
      createTime: dayjs().unix(),
      result: JSON.stringify({ default: result }),
      input: JSON.stringify(input),
    });

    console.log('[historyService] addHistory response:', response.data);

    if (response.data.success) {
      // 添加到 HistoryStore
      HistoryStore.data[0].unshift(response.data.data);

      // 生成标题
      HistoryStore.genTitle(userId, response.data.data.id);

      // 提交评测
      try {
        const evaluationResponse = await ApiService.addEvaluation({
          result,
          Content: input.Content || '',
          Industry: input.Industry || '',
          Output_type: input.Output_type || '',
          historyId: response.data.data.id || '',
        });
        console.log('[historyService] Evaluation response:', evaluationResponse.data);
      } catch (error) {
        handleWarnWithErr(error, 'Failed to submit evaluation');
      }

      return {
        success: true,
        historyId: response.data.data.id,
      };
    } else {
      handleError(new Error(response.data.data.message), ERROR_MESSAGES.NETWORK_ERROR);
      return {
        success: false,
        error: new Error(response.data.data.message),
      };
    }
  } catch (error) {
    handleError(error, ERROR_MESSAGES.NETWORK_ERROR);
    return {
      success: false,
      error: error instanceof Error ? error : new Error('Unknown error'),
    };
  }
}
